module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('booking')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8da36810"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Home.vue
// module id = 746
// module chunks = 1